import { render, staticRenderFns } from "./TrimList.vue?vue&type=template&id=50bfed3c&"
import script from "./TrimList.vue?vue&type=script&lang=js&"
export * from "./TrimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports